import { render, staticRenderFns } from "./RenewPassword.vue?vue&type=template&id=181d1e99&"
import script from "./RenewPassword.vue?vue&type=script&lang=js&"
export * from "./RenewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports